import { useNavigate } from 'react-router'
import { Avatar, Dropdown, type DropdownItem } from 'wss3-forge'
import { Settings20Regular, SignOut20Regular } from '@fluentui/react-icons'
import { useAuth } from '../contexts/AuthContext.js'

export function UserMenu() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  if (!user) return null

  const items: DropdownItem[] = [
    { id: 'name', label: user.name, disabled: true },
    { id: 'email', label: user.email, disabled: true },
    { id: 'sep', label: '', divider: true },
    {
      id: 'settings',
      label: 'Réglages',
      icon: <Settings20Regular />,
      onClick: () => navigate('/settings'),
    },
    { id: 'sep2', label: '', divider: true },
    {
      id: 'logout',
      label: 'Déconnexion',
      icon: <SignOut20Regular />,
      destructive: true,
      onClick: () => void logout(),
    },
  ]

  // Webba ID avatar via `src`, initials fallback via `name`.
  // `showTooltip` is a real runtime prop on Forge Avatar (default true) but it's
  // missing from the public AvatarProps type — spread it loose-typed to suppress
  // the on-hover name tooltip we don't want here (the dropdown carries the name).
  const noTooltipProps = { showTooltip: false } as Record<string, unknown>
  const trigger = (
    <Avatar
      {...(user.avatar ? { src: user.avatar } : {})}
      name={user.name}
      size="sm"
      onClick={() => {}}
      {...noTooltipProps}
    />
  )

  return <Dropdown trigger={trigger} items={items} align="right" width={240} />
}
